import { DataAttributeDefinitions } from 'scrivito'

import { pisaGlobalResultDataClass } from './Pisa/pisaGlobalResultDataClass'

const attributes: DataAttributeDefinitions = {}

export const GlobalResult = pisaGlobalResultDataClass(attributes)
